<script lang="ts" setup>
    const model = defineModel()
</script>

<template>
    <component v-model="model" type="hidden" />
</template>
